import { Breadcrumb, Card, Dropdown, Row } from 'react-bootstrap';
import Avatar from 'react-avatar';
import styled, { css } from 'styled-components';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import {
  getButtonHover,
  getColor,
  getDarkenColor,
} from '../../../utils/helper';

export const PageWrap = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  color: ${({ theme }) => theme.primaryLight3};
  padding: ${({ isTable }) => (isTable ? '0 32px' : '0 15px 32px 15px')};
  font-weight: 400;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '1004px')};
  margin: ${({ isTable }) => (isTable ? '15px auto 0' : '30px auto')};
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.mainPrimary};
    border-color: ${({ theme }) => theme.mainPrimary};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.lg}px) {
      padding: 0 16px 16px 16px;
    }
  `}
`;

export const ButtonText = styled.span`
  font-size: ${({ fontSize }) => fontSize || '18px'};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 600;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.lg}px) {
      font-size: 14px;
    }
  `}
`;

export const EditButton = styled(StyledButton)`

  disabled: ${({ disabled }) => disabled ? 'disabled' : ''} !important;  
  font-family: ${({ theme }) => theme.fontFamily};
  padding: ${({ padding }) => padding || '9px 16px'} !important;
  box-shadow: ${({ noBoxShadow }) =>
    !noBoxShadow
      ? `0 0 4px 0 rgba(0, 0, 0, 0.11),
    0 8px 16px 0 ${({ theme, color }) => `${color ?? theme.primary}3D`}`
      : 'none'};

  border: ${({ border, color, theme, variant, active }) =>
    border == 'none'
      ? 'none'
      : active
      ? `1.5px solid ${theme.dark30}`
      : variant === 'outline' && color === 'heading'
      ? `1.5px solid ${theme.dark70}`
      : `1.5px solid ${getColor(color, theme)}`};

  background-color: ${({ color, theme, variant }) =>
    variant === 'outline' && color === 'heading'
      ? theme.transparent
      : getColor(color, theme)};

  color: ${({ color, theme, variant }) =>
    variant === 'outline' && color === 'heading'
      ? theme.heading
      : variant !== 'outline'
      ? getButtonHover(color, theme)
      : theme.white};

  ${(props) =>
    props.type === 'error' &&
    css`
      background-color: ${({ theme }) => theme.white};
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.11),
        0 8px 16px 0 rgba(0, 0, 0, 0.12);
      color: ${({ theme }) => theme.error};
      &:hover {
        background-color: ${({ theme }) => theme.white}!important;
        color: ${({ theme }) => getButtonHover('error', theme)}!important;
      }
    `}

  &:hover {
    background-color: ${({ color, theme, variant }) =>
      variant === 'outline' && color === 'heading'
        ? theme.dark70
        : getDarkenColor(color, theme)};
    color: ${({ color, theme, variant }) =>
      variant === 'outline' && color === 'heading'
        ? theme.heading
        : variant !== 'outline'
        ? getButtonHover(color, theme)
        : theme.white};
  }

  ${(props) =>
    (props.type === 'icon-btn' || props.variant === 'icon-btn') &&
    css`
      background-color: ${({ theme }) => theme.transparent};
      box-shadow: none !important;
      color: ${({ theme }) => theme.heading};
      &:hover {
        background-color: ${({ theme }) => theme.transparent}!important;
        color: ${({ theme }) => getButtonHover('heading', theme)}!important;
      }
    `}

  ${(props) =>
    (props.type === 'icon-btn-text' || props.variant === 'icon-btn-text') &&
    css`
      background-color: ${({ theme }) => theme.transparent};
      box-shadow: none !important;
      color: ${({ theme }) => theme.heading};
      font-weight: 600;
      border: 2px solid ${({ theme }) => theme.primary};
      &:hover {
        background-color: ${({ theme }) => theme.transparent}!important;
        color: ${({ theme }) => getButtonHover('heading', theme)}!important;
      }
    `}
`;

export const CompanyInfoHeader = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.dark80};
  padding-bottom: 25px;
`;
export const CompanyDetails = styled(Row)`
  padding: 25px 0;
`;

export const StyledCompanyImage = styled.div`
  position: relative;
  .upload-image {
    position: absolute;
    z-index: 99;
    background-color: ${({ theme }) => theme.white};
    padding: 3px 5px 5px 5px;
    border-radius: 50%;
    bottom: 0;
    right: 0;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
    color ${({ theme }) => theme.dark10};
    cursor: pointer;
    transition: transform 0.3s ease;
    &:hover {
      transform: translateY(-5px); /* Move the element 5px up on hover */
    }
  }
`;

export const H6 = styled.div`
  color: ${({ theme }) => theme.heading};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 600;
  font-size: 18px;
`;

export const H5 = styled.div`
  color: ${({ theme }) => theme.bodyMedium};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 400;
  font-size: 16px;
`;
export const PageTitle = styled.h5`
  font-size: 24px;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 600;
  color: ${({ theme }) => theme.heading};
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      font-size: 16px;
    }
  `}
`;

export const NewPageTitle = styled.div`
  .heading {
    font-size: 20px;
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: 600;
    color: ${({ theme }) => theme.heading};

    &.heading24 {
      font-size: 24px;
    }
    &.heading18 {
      font-size: 18px;
    }
    .back-icon {
      cursor: pointer;
      transition: transform 0.3s ease;
      &:hover {
        transform: translateX(-5px); /* Move the element 5px up on hover */
      }
    }
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 10px 20px;
  box-shadow: ${({ withOutBorder }) =>
    withOutBorder
      ? 'none'
      : '0 0 6px 0 rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.08)'};
  border-bottom: ${({ theme, hasBorder }) =>
    hasBorder ? `1px solid ${theme.dark70}` : 'none'};
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      padding: 8px 16px;
      .heading {
        font-size: 16px;
        font-family: ${({ theme }) => theme.fontFamily};
        font-weight: 600;
        color: ${({ theme }) => theme.heading};

        &.heading24 {
          font-size: 18px;
        }
        &.heading18 {
          font-size: 12px;
        }
      }
    }
  `}
`;

export const BootstrapCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 15px 20px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.02), 0 -2px 4px 0 rgba(0, 0, 0, 0.08);
`;

export const NewFormLabel = styled.label`
  font-size: 18px;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.heading};
  font-weight: 600;
  margin-bottom: 0.6rem;

  .title {
    position: relative;
    &.required {
      &::after {
        content: '*';
        position: absolute;
        right: -9px;
        top: 0;
        display: block;
        color: red;
      }
    }
    &._light {
      font-weight: 500;
    }
  }
`;

export const SmallHeading = styled.h5`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 600;
  color: ${({ theme }) => theme.dark10};
`;

export const SmallTwo = styled.h5`
  font-size: 11px;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 400;
  color: ${({ theme }) => theme.dark40};
`;

export const OrderHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-switch {
    .form-check-input {
      width: 4em;
      height: 2em;
    }
  }
`;
export const FormLabel = styled.label`
  font-size: 16px;
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: normal;
  margin-bottom: 0.6rem;
  position: relative;
  &.required {
    &::after {
      content: '*';
      position: absolute;
      right: -8px;
      top: 0;
      display: block;
      color: red;
    }
  }
`;

export const BootstrapCard = styled(Card)`
  padding: 25px 30px;
  box-shadow: ${({ withOutBorder }) =>
    withOutBorder
      ? '0 0 6px 0 rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.06)'
      : '0 -3px 4px 0 rgba(0, 0, 0, 0.04), 0 4px 8px 0 rgba(0, 0, 0, 0.06)'};
  border: 0;
  font-family: ${({ theme }) => theme.fontFamily};
  margin-bottom: 16px;
  input {
    border-radius: 8px;
    border-color: ${({ theme }) => theme.lightGray1};
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      padding: 20px;
    }
  `}

  &.full-height {
    height: calc(100% - 16px);
  }
`;

export const BootstrapCollapseCard = styled(Card)`
  padding: ${({ padding }) => padding || '24px'};
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.04), 0 4px 8px 0 rgba(0, 0, 0, 0.06);
  border: 0;
  font-family: ${({ theme }) => theme.fontFamily};
  margin-bottom: 16px;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      padding: 15px;
    }
  `}
`;
export const PolicyTable = styled(Card)`
  padding: 0;
  thead {
    tr {
      th {
        padding: 20px;
        border-bottom: 1px solid ${({ theme }) => theme.lightGray1};
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.heading};
        background-color: ${({ theme }) => theme.dark95};
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 20px;
        font-size: 14px;
        font-weight: 500;
        border: 0;
        color: ${({ theme }) => theme.secondaryLight};
        background-color: #fff;
        > svg {
          margin-right: 20px;
          color: ${({ theme }) => theme.mainPrimary};
        }
        .badge {
          font-size: 14px;
          font-weight: normal;
          border-radius: 30px;
          padding: 10px 15px;
          &.badge-active {
            color: ${({ theme }) => theme.success};
            background-color: ${({ theme }) => theme.success3};
          }
          &.badge-inactive {
            color: ${({ theme }) => theme.danger2};
            background-color: ${({ theme }) => theme.danger3};
          }
        }
      }
      // &:nth-child(even) {
      //   td {
      //     background-color: ${({ theme }) => theme.lightGray2};
      //   }
      // }
    }
  }
`;

export const BreadcrumbStyle = styled(Breadcrumb)`
  margin-bottom: 0;
  .breadcrumb-item {
    font-size: 18px;
    color: ${({ theme }) => theme.secondaryLight};
    font-weight: 400;
    a {
      color: ${({ theme }) => theme.secondaryLight};
      text-decoration: none;
    }
    + .breadcrumb-item::before {
      color: ${({ theme }) => theme.secondaryLight};
    }
  }
`;

export const FooterPagination = styled.div`
  padding: 0 32px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const RowSelect = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  white-space: nowrap;
`;
export const TextPrimaryLight = styled.span`
  color: ${({ theme }) => theme.mainPrimary} !important;
  font-weight: 400;
`;

export const PageResult = styled.span`
  color: ${({ theme }) => theme.menuText};
  font-weight: 400;
`;

export const UploadWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const HelperText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.primaryDark};
`;

export const UserImg = styled.img`
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 10px;
`;

export const RoleList = styled.ul`
  padding-left: 20px;
  li {
    list-style: none;
    padding-top: 10px;
  }
`;

export const PreviewWrap = styled.div`
  flex: 1;
  margin-left: 30px;
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      position: relative;
      float: left;
      img {
        width: 98px;
        height: 98px;
        border-radius: 10px;
        object-fit: cover;
      }
      svg {
        position: absolute;
        right: -10px;
        top: -10px;
        background-color: ${({ theme }) => theme.white};
        color: ${({ theme }) => theme.primary};
        padding: 2px;
        border-radius: 100%;
      }
    }
  }
`;

export const FileUpload = styled.div`
  border: 2px dashed ${({ theme }) => theme.lightGray1};
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  max-width: 240px;
  cursor: pointer;
  margin-bottom: 5px;
  position: relative;
  input[type='file'] {
    opacity: 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  p {
    color: ${({ theme }) => theme.primaryLight};
    font-weight: 400;
    line-height: 26px;
    span {
      display: block;
      font-weight: 600;
      color: ${({ theme }) => theme.mainPrimary};
    }
  }
  label svg {
    color: ${({ theme }) => theme.mainPrimary};
  }
`;

export const ShopInfo = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.secondaryLight};
  font-size: 18px;
  position: relative;
  font-weight: 600;
  padding-left: 30px;
  line-height: 34px;
  &::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 15px;
    width: 5px;
    height: 5px;
    display: block;
    background-color: ${({ theme }) => theme.secondaryLight};
    border-radius: 100%;
  }
  &.address {
    &::before {
      display: none;
    }
  }
`;

// &::before {
//   content: '';
//   position: absolute;
//   left: 10px;
//   top: 15px;
//   width: 5px;
//   height: 5px;
//   display: block;
//   background-color: ${({ theme }) => theme.secondaryLight};
//   border-radius: 100%;
// }

export const SocialLink = styled.ul`
  padding: 0;
  margin: 0;
  cursor: pointer;
  li {
    color: ${({ theme }) => theme.secondaryLight};
    font-size: 18px;
    font-weight: 600;
    list-style: none;
    line-height: 34px;
    svg {
      margin-right: 10px;
      vertical-align: middle;
      color: ${({ theme }) => theme.mainPrimary};
    }
  }
`;

export const ShopMenu = styled.div`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  padding: 15px 0;
  overflow: hidden;
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      color: ${({ theme }) => theme.secondaryLight};
      padding: 12px 30px;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      &.active {
        color: ${({ theme }) => theme.mainPrimary};
        &:before {
          content: '';
          position: absolute;
          left: -3px;
          top: 5px;
          bottom: 5px;
          width: 8px;
          background-color: ${({ theme }) => theme.mainPrimary};
          border-radius: 0 15px 15px 0;
        }
      }
      svg {
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        font-weight: 400;
        vertical-align: middle;
      }
    }
  }
`;

export const BankDetail = styled.ul`
  padding: 20px 25px;
  margin-bottom: 0;
  li {
    list-style: none;
    font-family: ${({ theme }) => theme.fontFamily};
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 34px;
    span {
      color: ${({ theme }) => theme.dark40};
    }
    h6 {
      width: 20%;
      font-family: ${({ theme }) => theme.fontFamily};
      font-size: 16px;
      font-weight: 400;
      margin-right: 15px;
      margin-bottom: 0;
      color: ${({ theme }) => theme.heading};
      ${({ theme }) => css`
        @media (max-width: ${theme?.breakpoints?.lg}px) {
          width: auto;
          font-size: 14px;
        }
      `}
    }
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.lg}px) {
      padding: 10px 15px;
      li {
        font-size: 14px;
      }
    }
  `}
  .__details {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    li {
      h6 {
        width: auto;
      }
    }
  }
  .badge {
    font-size: 14px;
    font-weight: 600;
    border-radius: 4px;
    padding: 10px 15px;
    &.badge-active {
      color: ${({ theme }) => theme.success};
      background-color: ${({ theme }) => theme.success3};
    }
    &.badge-inactive {
      color: ${({ theme }) => theme.danger2};
      background-color: ${({ theme }) => theme.danger3};
    }
  }
`;

export const BankDetailsAction = styled(Dropdown)`
  .dropdown-toggle {
    background-color: transparent;
    color: #bfb8c2;
    border: 0;
    padding: 0;
    &:after {
      content: normal;
    }
  }
  .dropdown-menu {
    padding: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    border: 0;
    overflow: hidden;
    .dropdown-item {
      font-size: 16px;
      padding: 10px 20px;
      cursor: pointer;
      &:not(:last-child) {
        border-bottom: 1px solid #e3e3e3;
      }
      svg {
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        vertical-align: middle;
      }
      &:active {
        background-color: ${({ theme }) => theme.mainPrimary};
      }
    }
  }
`;

export const ShowTwoLine = styled.div`
  max-height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Number of lines to show */
  -webkit-box-orient: vertical;
`;

export const UserInitialImg = styled(Avatar)`
  .large-font {
    span {
      font-size: 40px;
    }
  }
  .med-font {
    span {
      font-size: 35px;
    }
  }
`;

export const ProductAddOnImageContainer = styled.div`
  cursor: pointer;
  img {
    max-height: 100px;
    width: auto;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: -15px;
  left: -15px;
  color: red;
  cursor: pointer;
  height: 50px;
  width: 50px;
  z-index: 1;
`;

export const ShopStyled = {
  PageWrap,
  PageTitle,
  OrderHead,
  FormLabel,
  PolicyTable,
  BankDetailsAction,
  BankDetail,
  ShopMenu,
  ShopInfo,
  SocialLink,
  BreadcrumbStyle,
  FooterPagination,
  TextPrimaryLight,
  RowSelect,
  PageResult,
  UploadWrap,
  FileUpload,
  HelperText,
  PreviewWrap,
  UserImg,
  RoleList,
  BootstrapCard,
  ShowTwoLine,
  BootstrapCollapseCard,
  UserInitialImg,
  EditButton,
  ButtonText,
  CompanyInfoHeader,
  CompanyDetails,
  H5,
  H6,
  SmallTwo,
  SmallHeading,
  StyledCompanyImage,
  NewFormLabel,
  NewPageTitle,
  BootstrapCardFooter,
  ProductAddOnImageContainer,
  CloseIconContainer,
};
